<script setup lang="ts">
import { onMounted, ref } from 'vue';
import useLocale from '../../../composables/use-locale';

const emit = defineEmits<{
  (e: 'complete'): void;
}>();

const { t } = useLocale();

const show = ref(false);

onMounted(() => {
  // Trigger animation immediately
  show.value = true;

  // Auto-complete after animation duration (2 seconds)
  setTimeout(() => {
    emit('complete');
  }, 2000);
});
</script>

<template>
  <div class="d-flex align-center justify-center" style="min-height: 400px">
    <h1 class="chalkduster-font final-question-text" :class="{ show: show }">
      {{ t('results.final_question_announcement') }}
    </h1>
  </div>
</template>

<style scoped lang="scss">
.final-question-text {
  font-size: clamp(2rem, 5vw, 4rem);
  text-align: center;
  margin: 0;
  text-shadow:
    3px 3px 0px rgba(0, 0, 0, 0.3),
    0 0 20px rgba(255, 255, 255, 0.3);
  letter-spacing: 0.05em;
  opacity: 0;
  transform: scale(0.2);

  &.show {
    animation: growHoldShrink 2s ease-in-out forwards;
  }
}

@keyframes growHoldShrink {
  0% {
    transform: scale(0.2);
    opacity: 0;
  }
  50% {
    transform: scale(1.1);
    opacity: 1;
  }
  75% {
    transform: scale(1.1);
    opacity: 1;
  }
  100% {
    transform: scale(0.3);
    opacity: 0;
  }
}
</style>
